export default __webpack_public_path__ + "static/Concrete-Recycling-Dumpsters-67198776e5a780ab515d7f2cba362c53.jpg";